import { formatDate } from "@/i18n";

/** Show the release date in place of the CI timestamp used as the patch number. */
export function desktopVersionLabel(version: string): string {
  const match = /^(\d+)\.(\d+)\.(\d{14})$/.exec(version);
  if (!match) return `Denker ${version}`;

  const stamp = match[3]!;
  const year = Number(stamp.slice(0, 4));
  const month = Number(stamp.slice(4, 6));
  const day = Number(stamp.slice(6, 8));
  const hour = Number(stamp.slice(8, 10));
  const minute = Number(stamp.slice(10, 12));
  const second = Number(stamp.slice(12, 14));
  const date = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
  if (
    date.getUTCFullYear() !== year ||
    date.getUTCMonth() + 1 !== month ||
    date.getUTCDate() !== day ||
    date.getUTCHours() !== hour ||
    date.getUTCMinutes() !== minute ||
    date.getUTCSeconds() !== second
  )
    return `Denker ${version}`;

  const released = formatDate(date, {
    month: "short",
    day: "numeric",
    year: "numeric",
    timeZone: "UTC",
  });
  return `Denker ${match[1]}.${match[2]} · ${released}`;
}
